import React from 'react';
import styles from './styles.module.scss';

interface IProps {
  children: JSX.Element | JSX.Element[];
}

const TabContentWrapper = (props: IProps) => (
  <div className={styles.wrapper}>{props.children}</div>
);

export default TabContentWrapper;
